import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core';

import { TrainingService } from '../training.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SessionStorageService } from '../../services/session-storage.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-training-nav',
  templateUrl: './training-nav.component.html',
  styleUrl: './training-nav.component.scss',
  imports: [MatIconModule, CommonModule, MatButtonModule],
})
export class TrainingNavComponent implements OnInit, OnDestroy, OnChanges {
  private router = inject(Router);
  private trainSvc = inject(TrainingService);
  private ss = inject(SessionStorageService);

  @Input() mode = 'landing';
  @Output() tabChange = new EventEmitter();
  @Input() currentTab: string;
  settings;
  courses;
  unsubscribe = new Subject();
  collapsed = false;

  ngOnInit(): void {
    this.collapsed = this.ss.get('trainingNavCollapsed');
    this.currentTab = this.trainSvc.currentApp() || 'landing';
    this.settings = this.ss.get('training')
      ? this.ss.get('training')['content']
      : null;
    this.courses = this.settings
      ? this.settings.find(x => x.app === this.currentTab)
      : null;

    this.trainSvc.trainingData$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(trainingRes => {
        this.settings = trainingRes['content'];
        this.courses = this.settings.find(x => x.app === this.currentTab);
      });
  }

  ngOnChanges(): void {
    if (this.settings) {
      this.courses = this.settings.find(x => x.app === this.currentTab);
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  showApp(app): boolean {
    let validApp = false;
    validApp = this.settings
      .find(x => x.app === app)
      ?.curriculum.some(curr => curr.right && this.showCourse(curr.right));
    return validApp;
  }

  showCourse(rights) {
    return this.trainSvc.rightsValid(rights);
  }

  goToHome() {
    this.router.navigate(['']);
  }

  setApp(tab, videoCode?) {
    this.currentTab = tab;
    this.courses = this.settings?.find(x => x.app === this.currentTab) ?? null;
    this.trainSvc.setApp(tab);
    if (videoCode) {
      this.tabChange.emit(videoCode);
      void this.router.navigate(['/training', tab, videoCode]);
    } else {
      this.tabChange.emit();
      void this.router.navigate(['/training', tab]);
    }
  }

  toggleNav(): void {
    this.collapsed = !this.collapsed;
    this.ss.set('trainingNavCollapsed', this.collapsed);
  }
}
